<template>
  <div
  class="spinner-overlay"
    :class="['modal', 'fade', { show: show, active: show }]"
    v-show="show"
    id="mediumModal"
    tabindex="-1"
    @click.self="shakeContent"
    role="dialog"
    aria-labelledby="mediumModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md modal-dialog-centered" role="document">
      <div class="modal-content" :class="{ shake: isShaking }">
        <div class="modal-header d-flex justify-content-between bg-secondary bg-opacity-75">
          <h5 class="modal-title text-light">
            {{ title }}
          </h5>
          <button
            @click="close"
            type="button"
            class="btn btn-danger close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div id="modalBody" class="modal-body">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from "vue"
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default() {
        return "Modal Title";
      },
    },
  },
  setup(props, { emit }) {
    const close = () => {
      emit("close");
    };
const isShaking = ref(false);
const shakeContent = () => {
  isShaking.value = true;
  setTimeout(() => {
    isShaking.value = false;
  }, 500); // Duration matches animation
};
    return {
      close,
      isShaking,
      shakeContent
    };
  },
};
</script>

<style scoped>
@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

.shake {
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}
.spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  pointer-events: auto;
}
.modal-content {
  pointer-events: auto;
}
.show {
  display: block;
  opacity: 0;
  /* Initially hidden */
  transition: opacity 0.9s ease;
  /* Transition effect */
}

.show.active {
  opacity: 1;
}

/* Responsive width for the modal dialog */
.modal-dialog.modal-md {
  max-width: 50%; /* Default size for larger screens */
}

@media (max-width: 768px) {
  .modal-dialog.modal-md {
    max-width: 90%; /* Adjust to fit mobile screens */
  }
}

@media (max-width: 576px) {
  .modal-dialog.modal-md {
    max-width: 100%; /* Full width on extra small screens */
  }
}
</style>
